import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { alertActions, userActions } from '_store';
import { getIcons } from '_helpers';
import { DeleteModal } from '_components/modals';
import { CustomTable } from '_components/table/CustomTable';

export { List };

function List() {
    const [data, setData] = useState([]);
    const users = useSelector(x => x.users.list);
    //const auth = useSelector(x => x.auth.value);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [show, setShow] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null)

    useEffect(() => {
        dispatch(userActions.getAll());
    }, []);

    /* Modification de l'objet reçu de l'api en tableau d'objets */
    useEffect(() => {
        if (users?.value) {
            const values = Object.entries(users.value).map(([key, value]) => {
                // Créer une nouvelle copie de l'objet avec l'ID ajouté si absent
                if (!value.hasOwnProperty('id')) {
                    return { ...value, id: key };
                }
                return { ...value };
            });
            setData(values);
        }
    }, [users]);

    /* Gestion des actions de modification et de suppression */
    const handleClose = () => setShow(false);

    const handleShow = (user) => {
        setUserToDelete(user.username);
        setShow(true);
    }

    async function handleDelete() {
        dispatch(alertActions.clear());
        try {
            await dispatch(userActions.delete(userToDelete));
            dispatch(alertActions.success({ message: 'Utilisateur supprimé avec succès', showAfterRedirect: true }));;
        } catch (error) {
            dispatch(alertActions.error(error?.message));
        }        
        setShow(false);
    }

    const handleEditUser = (user) => {
        navigate(`edit/${user.username}`)
    }

    const headers = [
        { label: 'Prénom', key: 'firstName', type: 'string', canToggle: false, visible: true},
        { label: 'Nom', key: 'lastName', type: 'string', canToggle: false, visible: true },
        { label: 'Nom d\'utilisateur', key: 'username', canToggle: false, visible: true },
        { label: 'Rôle', key: 'role', type: 'string', canToggle: false, visible: true },
        { label: '', key: 'edit', type: 'action', action: handleEditUser, icon: 'editOutlined', canToggle: false, visible: true },        
        { label: '', key: 'delete', type: 'action', action: handleShow, icon: 'deleteForeverOutlined', canToggle: false, visible: true },
    ]

    return (
        <>
            { users && 
                <div className='m-10 px-12'>                    
                    <div className="custom-table-container">
                        <div className={'flex justify-between items-center'}>
                            <div className="flex items-center">
                                <span className={'title-customtable'}> Gestion des utilisateurs </span>
                            </div>                        
                            <button className='btn-custom btn-custom-primary' onClick={() => navigate('add')}>
                                <img src={getIcons('addOutlined')} className='btn-custom-icon mt-[-4px]' alt='manage alerts' />
                                Créer un utilisateur
                            </button>                        
                        </div>
                        <div className={"my-4 "}>
                            <CustomTable data={data} headers={headers} maxHeight={'75vh'}/>
                        </div>
                    </div>
                    <DeleteModal
                        show={show}
                        handleClose={handleClose}
                        handleDelete={handleDelete}
                        entityName={`l'utilisateur ${userToDelete}`} 
                    />
                </div>
            }
        </>
    )
}
